const countries = {
  slug: 'f/countries',
  getCurrentCountyInfo: () => `${countries.slug}/current`,
  getCountriesAutocomplete: () => `${countries.slug}/autocomplete`
}

export default countries
